import React from 'react';
import Label from 'components/_utility/Label';
import { useDispatch, useSelector } from 'react-redux';
import { getPack, getPackSelectedTotal, getPackFittingTimeTotal } from 'src/redux/bike/selectors';

import ItemWrapper from 'components/BikeSummaryItem/BikeSummaryItem';
import { setStep } from 'src/redux/configurator/actions';
import useSteps from 'src/hooks/useSteps';
import useDataLayer from 'src/hooks/useDataLayer';
import { Section, Header, HeaderTitle, ItemsSummary } from './SummaryPackCard.styled';

const SummaryPackCard = () => {
  const pushToDataLayer = useDataLayer();
  const pack = useSelector(getPack);
  const dispatch = useDispatch();
  const steps = useSteps();
  const packsStep = steps.find(step => step.packs === true);
  const packTotal = useSelector(getPackSelectedTotal);
  const packFittingTimeTotal = useSelector(getPackFittingTimeTotal);

  return (
    <Section>
      <Header>
        <HeaderTitle>
          <Label name="packLabel" />
        </HeaderTitle>
      </Header>
      <ItemsSummary>
        {pack && (
          <ItemWrapper
            image={pack.thumbnail}
            name={pack.name}
            price={packTotal}
            fittingTime={packFittingTimeTotal}
            hasCTA
            ctaAction={() => [pushToDataLayer('configuratorPacks'), dispatch(setStep(packsStep.number))]}
            ctaLabel="editLabel"
          />
        )}
      </ItemsSummary>
    </Section>
  );
};

export default SummaryPackCard;
